import React from "react";
import { Typography } from "antd";
import avatarPlaceholder from "src/assets/avatar-placeholder.jpg";
import type { StaffDTO } from "api";

import { StaffMemberContainer, StaffMemberImage } from "./BusinessStaffMember.styles";

export interface BusinessStaffMemberProps {
  member: StaffDTO;
}

const BusinessStaffMember: React.FC<BusinessStaffMemberProps> = ({ member: { fullName, photoUrl } }) => {
  return (
    <StaffMemberContainer vertical>
      <StaffMemberImage src={photoUrl || avatarPlaceholder} alt="Staff" />
      <Typography.Text type="secondary" title={fullName} ellipsis>
        {fullName}
      </Typography.Text>
    </StaffMemberContainer>
  );
};

export default BusinessStaffMember;
